(function() {
    'use strict';

    angular
        .module('signatureApp')
        .controller('SignatureImgController', SignatureImgController);

    SignatureImgController.$inject = ['$scope', '$uibModalInstance','id','$uibModal','NgTableParams','FileNetService','GLOBAL_URL'];

    function SignatureImgController ($scope, $uibModalInstance,  id ,$uibModal, NgTableParams, FileNetService,GLOBAL_URL) {
    	var signatureImgDlgCtrl = this;
    	signatureImgDlgCtrl.url= GLOBAL_URL+'file-net/show-image?guid='+id;
    	signatureImgDlgCtrl.ok= ok;
    	signatureImgDlgCtrl.cancel= cancel;
    	signatureImgDlgCtrl.selected = {
    	  };

    	  function ok() {
    	    $uibModalInstance.close(signatureImgDlgCtrl.selected.item);
    	  };

    	  function cancel() {
    	    $uibModalInstance.dismiss('cancel');
    	  };
    	  
    	  
    }
})();
